import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 py-6 sm:py-10">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6" style={{ fontFamily: "Outfit" }}>Todas as categorias</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        {cats.map((c) => (
          <Link key={c.slug} to={`/categoria/${encodeURIComponent(c.name)}`} className="group block relative aspect-square rounded-xl overflow-hidden">
            <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <span className="absolute bottom-3 left-3 text-white font-bold">{c.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
